<template>
  <v-container>
    <v-row>
      <v-col>
        <flow-multi-stepper
          v-if="schema.multipleSteps"
          ref="flowPreview"
          :key="flowKey"
          :schema="schema"
          :steps-before-count="stepsBeforeCount"
          v-model="model"
          @submit="onAnswer">
          <template slot="steps-before">
            <slot name="steps-before"></slot>
          </template>
          <template slot="steps-after">
            <slot name="steps-after"></slot>
          </template>
        </flow-multi-stepper>
        <flow-stepper
          v-else
          ref="flowPreview"
          :key="flowKey"
          :schema="schema"
          :steps-before-count="stepsBeforeCount"
          v-model="model"
          @submit="onAnswer"
        >
          <template slot="steps-before">
            <slot name="steps-before"></slot>
          </template>
          <template slot="steps-after">
            <slot name="steps-after"></slot>
          </template>
        </flow-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {_} from 'vue-underscore';
  import {ComponentWithModelMixin} from "../../mixins/FlowGenerator";
  import FlowMultiStepper from "./FlowMultiStepper";
  import FlowStepper from "./FlowStepper";

  export default {
    name: "FlowGenerator",
    components: {FlowStepper, FlowMultiStepper},
    mixins: [ComponentWithModelMixin],
    props: {
      schema: Object,
      stepsBeforeCount: {
        type: Number,
        default: 0
      },
      fallback: {
        type: Function,
        // eslint-disable-next-line no-unused-vars
        default: function(model = {}) {
          // console.log('fallback function could be customized')
          // console.log(model)
        }
      }
    },
    data() {
      return {
        model: {},
        flowKey: 0
      };
    },
    methods: {
     onAnswer(val) {
        this.$emit("onAnswer", val);
        this.fallback(this.model);
        this.cleanData();
      },
      cleanData() {
        this.model = {};
        this.flowKey += 1;
      },
      cleanModel(exclude = []) {
        const storedData = _.pick(
          this.model, (value, key) => exclude.includes(key)
        )
        this.cleanData()
        return storedData
      },
      restoreModel(data = {}) {
        this.model = data
      },
      flowPreview() {
        return this.$refs.flowPreview
      }
    }
  }
</script>

<style scoped>

</style>
